var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MySpaceTasksWidgets',{attrs:{"type":"personalTasks"}})
}
var staticRenderFns = []

export { render, staticRenderFns }